import React, { useEffect } from 'react';
export default function Auth({ history }) {
    useEffect(() => {
        localStorage.clear();
    }, []);

    return (<></>)
}
